import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SubmitButton from '../submitButton/SubmitButton';

const FooterBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isAuthPage =
    location.pathname === '/login' || location.pathname === '/register';

  return (
    <div className="px-3 px-lg-0 position-absolute w-100">
      <div className=" bg-white p-4 br_10 w-100 container footerBanner">
        {/* Decorative Strips */}
        <div className="footerbannerStripBox position-absolute d-none d-md-block"></div>
        <div className="footerbannerStripBox position-absolute d-none d-md-block"></div>
        <div className="footerbannerStripBox position-absolute d-none d-md-block"></div>
        <div className="footerbannerStripBox position-absolute d-none d-md-block"></div>

        {/* Heading */}
        <h2 className="font_600 mb-0 HomeBannerText ourproductMainhead font_14 line_height1_7 text-black text-center pt-2">
          Ready to Get Started?
        </h2>

        {/* Description */}
        <p className="font_14 font_500 line_height1_7 text_light1 text-center mt-3">
          Experience the power of Trial Platform today
        </p>

        {/* Buttons */}
        <div className="position-relative d-flex justify-content-center gap-2">
          {!isAuthPage && (
            <SubmitButton
              style={{ marginTop: '0px' }}
              className="mt-0 rounded-pill"
              onClick={() => navigate('/products')}
              label="Get Started"
            />
          )}
          <SubmitButton
            style={{ marginTop: '0px' }}
            className="mt-0 rounded-pill btn-master-line"
            onClick={() => navigate('/sales-query')}
            label="Talk to Sales"
          />
        </div>
      </div>
    </div>
  );
};

export default FooterBanner;
